import {useEffect, useMemo} from "react";
import {useHistory} from "react-router-dom";
import {routesBase} from "v4/data/appRoutes";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useNotification from "v4/hooks/useNotification";
import useFetch from "v4/hooks/useFetch";
import apiService from "v4/services/api.service";
import {
    MODULE_CONFIGURATION_ADD,
    MODULE_CONFIGURATION_EDIT_FORM,
    MODULE_CONFIGURATION_FORM,
    MODULE_CONFIGURATION_ITEM
} from "v4/data/apiRoutes";
import schemaFormToV4Form from "v4/utils/schemaFormToV4Form";
import {CHECKBOX_TYPE, HIDDEN_TYPE} from "v4/data/fieldTypes";
import useAutoFetch from "v4/hooks/useAutoFetch";

export default function useModuleConfigurationsForm(customerId, id, moduleId) {
    const {t} = usePolTranslation();
    const {addSuccessNotification, addErrorNotification} = useNotification();
    const {push} = useHistory();

    // Récupération du schéma du formulaire
    const {
        data: moduleConfigurationFormData,
        isLoading: isLoadingForm
    } = useAutoFetch(id
        ? apiService.generateUrl(MODULE_CONFIGURATION_EDIT_FORM, {id, customerId, moduleId})
        : apiService.generateUrl(MODULE_CONFIGURATION_FORM, {customerId, moduleId})
    );

    // Pour la sauvegarde
    const [{
        data: moduleConfigurationDataSave,
        isError: isErrorSave,
        isLoading: isLoadingSave,
        isFinished: isFinishedSave
    }, fetchModuleConfigurationSave] = useFetch();

    // Conversion du schéma en format compatible FormRender
    const form = useMemo(() => {
        if (!moduleConfigurationFormData) return null;

        const _form = {
            results: schemaFormToV4Form(moduleConfigurationFormData)
        }

        // "keyConf" est le label de "value"
        _form.results.value.label = _form.results.keyConf.value;
        _form.results.keyConf.type = HIDDEN_TYPE;

        return _form;
    }, [moduleConfigurationFormData]);

    const handleSave = (data) => {
        fetchModuleConfigurationSave({
            url: id
                ? apiService.generateUrl(MODULE_CONFIGURATION_ITEM, {id})
                : apiService.generateUrl(MODULE_CONFIGURATION_ADD),
            config: {
                method: 'POST',
                body: JSON.stringify({
                    ...data,
                    ...((form.results.value?.type === CHECKBOX_TYPE && !form.results.value?.multiple) && {value: String(data.value)}),
                })
            }
        })
    }

    useEffect(() => {
        if (!isFinishedSave) return;

        if (isErrorSave) {
            addErrorNotification(t('module_configuration_save_error'))
            return;
        }

        addSuccessNotification(t('module_configuration_save_done'))
        push(`${routesBase.adminModuleConfiguration}/${customerId}/${moduleId}`)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moduleConfigurationDataSave, isErrorSave, isFinishedSave])

    return {
        form,
        isLoadingForm,
        isLoadingSave,
        handleSave,
    }
}
